import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import ReviewerProfileImageUploadDialog from "../../utils/dialogs/ReviewerProfileImageUploadDialog";

// Utils
import icon from "../../../utils/icons/user.js";

// State
import { updateReviewerImageClearStatus } from "../../../store/actions/reviewers";

class ProfilePic extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDialog: false
		};
	}

	handleClose = () => {
		this.setState(
			{
				showDialog: false
			},
			() => {
				this.props.updateReviewerImageClearStatus();
			}
		);
	};

	render() {
		const { translations, user } = this.props;
		const { showDialog } = this.state;

		return (
			<React.Fragment>
				<div
					className="col small-col profile-pic"
					onClick={e => this.setState({ showDialog: true })}
				>
					<div className="profile-pic-frame">
						{!!user.pic ? (
							<img src={user.pic} alt={`${user.fname} ${user.lname}`} />
						) : (
							icon
						)}
					</div>
				</div>
				<ReviewerProfileImageUploadDialog
					show={showDialog}
					user={user}
					handleClose={this.handleClose}
					translations={translations}
				/>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ updateReviewerImageClearStatus }
)(ProfilePic);



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ProfilePic.js